import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/shared/constants';
import { fetchAreas } from '../../api';

export function useAreas() {
  return useQuery({
    queryKey: [QUERY_KEYS.AZURE_DEVOPS_AREAS],
    queryFn: fetchAreas,
    staleTime: 5 * 60 * 1000, // 5 minutes - areas rarely change
  });
}
